import React from "react";
import Container from "@material-ui/core/Container";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";

const useStyles = makeStyles((theme) => ({
  accordion: {
    // Remove shadow
    boxShadow: "none",
    "&:before": {
      // Remove default divider
      display: "none",
    },
    // Add a custom border
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  expanded: {
    margin: `0 !important`,
  },
  summary: {
    minHeight: 78,
  },
  summaryContent: {
    margin: "0 !important",
  },
}));

function FaqSection(props) {
  const classes = useStyles();

  const items = [
    {
      question: "What is showNAV\?",
      answer:
        "ShowNAV is a logistics platform that streamlines crew access to location directories through the showNAV app, enhancing organization and communication across your production. Crew members can navigate directly to locations via GPS coordinates, ensuring pinpoint accuracy and eliminating user error. As an added safeguard, showNAV also auto-generates a map PDF for easy distribution to the production.",
    },
    {
      question: "Why should my production use showNAV?",
      answer:
        "showNAV enhances communication across your production, driving greater efficiency and reducing costs.",
    },
    {
      question: "Is the app free?",
      answer:
        "The showNAV app is free to crew! The production will pay a weekly fee for the service.",
    },
    {
      question: "How much will showNAV cost my production?",
      answer:
        "At just $500 per week per production, showNAV is an investment that pays for itself by boosting efficiency and improving communication. The real value lies in how much it saves your production-reducing delays, minimizing errors, and optimizing resources.",
    } 
  ];

  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container maxWidth="md">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={4}
          textAlign="center"
        />

        {items.map((item, index) => (
          <Accordion
            classes={{
              root: classes.accordion,
              expanded: classes.expanded,
            }}
            key={index}
          >
            <AccordionSummary
              classes={{
                root: classes.summary,
                content: classes.summaryContent,
              }}
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`faq-panel-${index}`}
            >
              <Typography variant="h6">{item.question}</Typography>
            </AccordionSummary>
            <AccordionDetails id={`faq-panel-${index}`}>
              <Typography>{item.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Section>
  );
}

export default FaqSection;
